import script from "./setPublicCommission.vue?vue&type=script&setup=true&lang=js"
export * from "./setPublicCommission.vue?vue&type=script&setup=true&lang=js"

import "./setPublicCommission.vue?vue&type=style&index=0&id=11bd24e6&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11bd24e6"]])

export default __exports__